import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const QuotationInvoiceTemplate = ({
  headerBase64,
  footerBase64,
  dgSignBase64,
  watermarkBase64,
  quotation,
  enquiry,
  quotationData,
  invoice_date,
  grandTotal,
  numberToWords,
  selectedValue,
  type,
  bankAc,
  invoice_no,
  tax_type,   
  tax_id,
   currency
}) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 15;
  const headerHeight = 28;
  const footerHeight = 25;
  const contentTop = headerHeight + 2;

  let isFirstPage = true;

  const addHeader = () => {
    if (headerBase64) doc.addImage(headerBase64, 'PNG', 0, 0, pageWidth, headerHeight);
  };

  const addWatermark = () => {
    if (!watermarkBase64) return;
    const wmWidth = pageWidth / 2;
    const wmHeight = wmWidth;
    const wmX = (pageWidth - wmWidth) / 2;
    const wmY = (pageHeight - wmHeight) / 2;

    doc.setGState(new doc.GState({ opacity: 0.08 }));
    doc.addImage(watermarkBase64, 'PNG', wmX, wmY, wmWidth, wmHeight);
    doc.setGState(new doc.GState({ opacity: 1 }));
  };

  const addPageFooter = () => {
    doc.setFontSize(8);
    doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber}`, pageWidth - margin, pageHeight - 5, { align: 'right' });
    if (footerBase64) doc.addImage(footerBase64, 'PNG', 0, pageHeight - footerHeight, pageWidth, footerHeight);
  };

  const addSignature = () => {
    if (!dgSignBase64) return;
    const sigWidth = 28;
    const sigHeight = 25;
    const sigX = pageWidth - sigWidth - margin;
    const sigY = pageHeight - footerHeight - sigHeight - 10;

    doc.addImage(dgSignBase64, 'PNG', sigX, sigY, sigWidth, sigHeight);
    doc.setFontSize(8);
    doc.text('Authorized Signatory', sigX, sigY + sigHeight + 4);
  };

  const drawTopSection = (startY = contentTop) => {
    let y = startY;
    // ← ALWAYS start from passed startY

    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');

    // add space above title
    doc.text(type, pageWidth / 2, y + 3, { align: 'center' });

    // add space below title
    y += 13;   // previously y += 8

    doc.setFontSize(11);
    doc.setFont(undefined, 'normal');
    doc.text(`Date: ${invoice_date ? new Date(invoice_date).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB")}`, margin, y);

    doc.text(`No: ${type === 'INVOICE' ? invoice_no || 'N/A' : quotation.qu_no || 'N/A'}`, pageWidth - margin, y, { align: 'right' });
    y += 6;

    // NEW BILLED TO BOX
    const boxStartY = y;   // reduce 8 → 4  (or even 0 if you want tight)

    const boxWidth = pageWidth - 2 * margin;
    const midX = margin + boxWidth * 0.62;

    // ---- LEFT SIDE content preview to calculate height ----
    let label = "Address:";
    const labelWidth = doc.getTextWidth(label);
    const addrValue = enquiry.address || "N/A";
    const addrLines = doc.splitTextToSize(addrValue, midX - margin - 10 - labelWidth);

    // ---- Calculate dynamic height ----
    const addrLinesCount = addrLines.length;

    const leftSideLines =
      1 +                  // BILLED TO
      addrLinesCount +     // Address wrapped lines
      1;                   // Contact

    const rightSideLines = 2; // TAX TYPE + TAX ID

    const totalLines = Math.max(leftSideLines, rightSideLines);

    // Each line approx = 6mm + top padding
    const boxHeight = 10 + (totalLines * 6);

    // ---- Draw background box ----
    doc.setFillColor(245, 245, 245);
    doc.rect(margin, boxStartY, boxWidth, boxHeight, 'F');


    // ---- LEFT SIDE ----
    let ty = boxStartY + 8;

    // Billed To
    label = "BILLED TO:";
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(label, margin + 5, ty);
    doc.setFont("helvetica", "normal");
    doc.text(enquiry.name || "N/A", margin + 5 + doc.getTextWidth(label) + 2, ty);

    ty += 7;

    // Address
    label = "Address:";
    doc.setFont("helvetica", "bold");
    doc.text(label, margin + 5, ty);
    doc.setFont("helvetica", "normal");

    addrLines.forEach(l => {
      doc.text(l, margin + 5 + doc.getTextWidth(label) + 2, ty);
      ty += 5;
    });

    // Contact
    label = "Contact:";
    doc.setFont("helvetica", "bold");
    doc.text(label, margin + 5, ty);
    doc.setFont("helvetica", "normal");
    doc.text(enquiry.mobile_no || "N/A", margin + 5 + doc.getTextWidth(label) + 2, ty);

    // ---- RIGHT SIDE ----
    ty = boxStartY + 8;

    label = "TAX TYPE:";
    doc.setFont("helvetica", "bold");
    doc.text(label, midX + 5, ty);
    doc.setFont("helvetica", "normal");
    doc.text(tax_type || enquiry.tax_type || "N/A", midX + 5 + doc.getTextWidth(label) + 2, ty);

    ty += 12;

    label = "TAX ID:";
    doc.setFont("helvetica", "bold");
    doc.text(label, midX + 5, ty);
    doc.setFont("helvetica", "normal");
    doc.text(tax_id || enquiry.tax_id || "N/A", midX + 5 + doc.getTextWidth(label) + 2, ty);

    // UPDATE Y for next section
    y = boxStartY + boxHeight + 3;   // reduces gap above Service box


    // Service box
    const serviceBoxHeight = 8;
    doc.setFillColor(235, 235, 235);
    doc.rect(margin, y, pageWidth - 2 * margin, serviceBoxHeight, 'F');

    // Removed the thick left border
    // doc.setDrawColor(0);
    // doc.setLineWidth(2);
    // doc.line(margin, y, margin, y + serviceBoxHeight);
    // doc.setLineWidth(0.1);

    doc.setFontSize(10);

    doc.text(`Service: ${enquiry.service_name || "N/A"}`, margin + 4, y + 6);

    y += serviceBoxHeight + 3;   // reduce bottom gap

    return y;
  };


  // First page setup
  addHeader();
  addWatermark();
  let tableStartY = drawTopSection();

  // Calculate the top section height for continuation pages
  const topSectionHeight = tableStartY - contentTop;

  // Table columns
  const tableColumns = [
    { header: 'SI NO', dataKey: 'si' },
    { header: 'DESCRIPTION', dataKey: 'description' },
    { header: 'QTY', dataKey: 'qty' },
    { header: 'UNIT PRICE', dataKey: 'unitprice' },
    { header: 'TAX (%)', dataKey: 'tax' },
    { header: 'TOTAL', dataKey: 'totalprice' }
  ];

// ... previous code until tableRows ...

const tableRows = quotationData.map((item, idx) => ({
  si: idx + 1,
  description: item.description || "-",
  qty: item.qty || 0,
  unitprice: (parseFloat(item.unitprice) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
  tax: item.tax || 0,
  totalprice: (parseFloat(item.totalprice) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })
}));

// Normal data rows
const allRows = tableRows.map(r => [
  r.si,
  r.description,
  r.qty,
  r.unitprice,
  r.tax,
  r.totalprice
]);


autoTable(doc, {
  startY: tableStartY,
  head: [tableColumns.map(c => c.header)],
  body: allRows,

  margin: { left: margin, right: margin, top: headerHeight + 1, bottom: footerHeight + 10 },
  theme: 'grid',

  headStyles: {
    fillColor: [41, 128, 185],
    textColor: [255, 255, 255],
    fontStyle: 'bold',
    halign: 'center',
    valign: 'middle',          // ✅ center vertically
    fontSize: 8,
    cellPadding: { top: 2, bottom: 2, left: 1, right: 1 }, // ✅ KEY FIX
    overflow: 'visible',       // ✅ stop wrapping
    minCellHeight: 8           // ✅ single-line height
  },

  bodyStyles: {
    textColor: [0, 0, 0],
    valign: 'middle',
    fontSize: 10,
    cellPadding: 5
  },

  columnStyles: {
    0: { cellWidth: 15, halign: 'center' }, // SI NO
1: { cellWidth: 65, halign: 'left' },   // DESCRIPTION

    2: { cellWidth: 15, halign: 'center' }, // QTY
    3: { cellWidth: 35, halign: 'right' },  // UNIT PRICE
    4: { cellWidth: 15, halign: 'center' }, // TAX (%)
    5: { cellWidth: 35, halign: 'right' }   // TOTAL
  },

  styles: {
    lineColor: [0, 0, 0],
    lineWidth: 0.1
  },

  pageBreak: 'auto',
  rowPageBreak: 'avoid',
  showHead: 'everyPage',

  didDrawPage: (data) => {
    addWatermark();
    addPageFooter();
    if (!isFirstPage) addHeader();
    if (isFirstPage) isFirstPage = false;
  }
});


let finalTerms = [];
if (selectedValue?.data) {
  const html = selectedValue.data;

  const withLineBreaks = html
    .replace(/<li>/gi, "\n")        // remove bullet here
    .replace(/<\/li>/gi, "")
    .replace(/<br\s*\/?>/gi, "\n")  // <br> to newline
    .replace(/<p[^>]*>/gi, "\n")    // <p> to newline
    .replace(/<\/p>/gi, "")
    .replace(/<\/?[^>]+(>|$)/g, "") // remove remaining HTML tags
    .trim();

  // Filter out empty lines
  finalTerms = withLineBreaks
    .split("\n")
    .map(line => line.trim())
    .filter(line => line.length > 0);
}


const boxMargin = margin;
const boxWidth = pageWidth - 2 * boxMargin;
// Move Y immediately below the table with minimal gap
let currentY = doc.lastAutoTable.finalY + 3;  // was +8

// Box height just enough for one line
const boxHeight = 10; // was 12

// Center the text vertically in box
const textY = currentY + boxHeight / 2 + 1; // was +3

// Draw box
doc.setDrawColor(0);
doc.setLineWidth(0.5);
doc.rect(boxMargin, currentY, boxWidth, boxHeight);

// Left: In Words
doc.setFontSize(10);
doc.setFont(undefined, 'normal');
doc.text(`In Words: ${numberToWords(grandTotal)} Only`, boxMargin + 3, textY);

// Right: Grand Total
doc.setFont(undefined, 'bold');
const grandTotalText = `Grand Total: ${currency ? currency + ' ' : ''}${Number(grandTotal).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;


doc.text(grandTotalText, pageWidth - boxMargin - doc.getTextWidth(grandTotalText) - 3, textY);

// Move Y for next content
currentY += boxHeight + 5;


// --- ESTIMATE HEIGHT NEEDED FOR TERMS + BANK DETAILS + SIGNATURE ---
// --------- REAL HEIGHT CALCULATION (FIX) ---------

// TERMS HEIGHT
const termsLineHeight = 6;
const termsHeight =
  finalTerms.length > 0
    ? 6 + finalTerms.length * termsLineHeight
    : 0;

// BANK DETAILS HEIGHT (dynamic wrapping)
let bankHeight = 0;
if (bankAc) {
  const bankLines = [
    `Account Holder: ${bankAc.holder_name || ''}`,
    `Bank: ${bankAc.bank_name || ''}`,
    `Account No: ${bankAc.ac_no || ''}`,
    `IFSC: ${bankAc.ifsc_code || ''}`,
    `${(bankAc.bank_address || '').replace(/\n/g, ' ')}`
  ];

  bankLines.forEach(line => {
    const wrapped = doc.splitTextToSize(line, 51);
    bankHeight += wrapped.length * 5.5;
  });

  bankHeight += 8; // BANK DETAILS title
}

// SIGNATURE HEIGHT (actual size)
const signatureHeight = pageWidth * 0.25 * 0.9 + 8;

// TOTAL REQUIRED HEIGHT
const requiredHeight =
  Math.max(termsHeight, bankHeight) +
  signatureHeight +
  8;

// PAGE BREAK CHECK
if (currentY + requiredHeight > pageHeight - footerHeight - 5) {
  doc.addPage();
  addHeader();
  addWatermark();
  currentY = headerHeight + 12;
}


// Separator line
doc.setDrawColor(0);
doc.setLineWidth(0.5);
doc.line(margin, currentY, pageWidth - margin, currentY);

currentY += 7; // extra top space after line

// TERMS & CONDITIONS on left
const leftX = margin;
doc.setFontSize(10); // increased font
doc.setFont(undefined, 'bold');
doc.text('TERMS & CONDITIONS:', leftX, currentY);
doc.setFontSize(9);
doc.setFont(undefined, 'normal');



currentY += 4.5; // small gap below title
finalTerms.forEach(line => {
  doc.text(`• ${line}`, leftX + 2, currentY);
  currentY += 6; // increased line spacing
});

if (bankAc) {
  const blockWidth = 55; // Reduced to shift the block further right (increases starting x-position while allowing wrapping; based on max line width ~51mm)
  const rightBankX = pageWidth - blockWidth;
  let bankY = currentY - (finalTerms.length * 7); // align top with TERMS

  const lineHeight = 5.3;
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('BANK DETAILS:', rightBankX, bankY);
  bankY += lineHeight;

  doc.setFontSize(9);
  doc.setFont(undefined, 'normal');

const bankLines = [
    `Account Holder: ${bankAc.holder_name || ''}`,
  `Bank: ${bankAc.bank_name || ''}`,
  `Account No: ${bankAc.ac_no || ''}`,
  `IFSC: ${bankAc.ifsc_code || ''}`,
  `${(bankAc.bank_address || '').replace(/\n/g, ' ')}`,  // just the address, no "Branch:"

];


  bankLines.forEach(rawLine => {
    // Split the line into wrapped parts that fit within blockWidth
    const wrapped = doc.splitTextToSize(rawLine, blockWidth - 4); // -4 for small left padding safety

    wrapped.forEach((part, i) => {
      doc.text(part, rightBankX, bankY);
      if (i < wrapped.length - 1) bankY += lineHeight; // add spacing only between wrapped parts
    });

    bankY += lineHeight; // space to next original line
  });


const sigWidth = pageWidth * 0.25;   // 25% of page width
const sigHeight = sigWidth * 0.9;    // adjust ratio slightly if needed

let sigX = pageWidth - sigWidth - margin;
let sigY = bankY + 5; // small gap from bank details

// If signature goes out of the page → move to next page
if (sigY + sigHeight + 10 > pageHeight - footerHeight) {
  doc.addPage();
  addHeader();
  addWatermark();
  sigY = headerHeight + 30;
}

// Draw signature image if exists
if (dgSignBase64) {
  doc.addImage(dgSignBase64, "PNG", sigX, sigY, sigWidth, sigHeight);
  doc.setFontSize(10);
  doc.text("Authorized Signatory", sigX, sigY + sigHeight + 1); // text just below image
} else {
  // No signature image → display text only
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text("Authorized Signatory", sigX, sigY); // place text where signature would be
}


}

addPageFooter();



  return doc;
};

export default QuotationInvoiceTemplate;